module.exports = __webpack_public_path__ + "img/pic_QR code@2x.67a914b.png";